import _ from 'lodash';
import * as utils from './utils';
import * as http from './http';
import Base from './Base';
import Derivative from './Derivative';

export default class Experiment extends Base {

   static urls = {
      all: '{host}/projects/{project}/subjects/{subject}/experiments/',
      one: '{host}/projects/{project}/subjects/{subject}/experiments/{experiment}',
      new: '{host}/projects/{project}/subjects/{subject}/experiments/{experiment}?{query}',
   }

   type = 'xnat:imageSessionData'

   create = utils.create()
   getDerivatives = utils.getChildren(Derivative)
   createDerivative = utils.createChild(Derivative)

   // data = { host, ID, project, subject, subject_name }
   constructor(data) {
      super();
      this.initialize(data);
   }

   initialize(data) {
      this.data = utils.rename(data, {
         ID: 'experiment',
      });
      this.data.query = this.getQuery();
   }

   getQuery() {
      const type = this.data.type || this.type;
      return `xsiType=${type}`;
   }

   getReviewData() {
      const label = this.data.label.replace(/^rev_/, ''); // INFO dirty
      const url = `{host}/projects/{project}/subjects/reviews/experiments/rev_${label}/?format=json`;
      return http.getJSON(utils.tpl(url, this.data))
         .then(
            data => _.mapValues(data.items[0].data_fields, value => (_.isString(value) ? utils.decodeHtmlEntities(value) : value)),
            () => null, // swallow error
         );
   }

   // TODO auf `save` umbauen (beim Erzeugen gleich korrekt Label und Typ setzen)
   saveReview(data) {
      const type = 'snrev:reviewData';
      const label = this.data.label.replace(/^rev_/, ''); // dirty but works (at present)
      const url = `{host}/projects/{project}/subjects/reviews/experiments/rev_${label}/?xsiType=${type}`;
      const fragments = _.map(data, (value, key) => `&${type}/${key}=${encodeURIComponent(value)}`);
      return utils.saveChunked(utils.tpl(url, this.data), fragments);
   }

   save(data) {
      const { type, element } = this.data;
      const url = '{host}/projects/{project}/subjects/{subject}/experiments/{experiment}?xsiType={type}';

      const mapEntry = (entry, prefix) => _.map(entry, (value, key) => `${prefix}/${key}=${encodeURIComponent(value)}`);

      const fragments = _.isArray(data)
         ? _.flatten(data.map((value, index) => mapEntry(value, `&${type}/${element}%5B${index}%5D`))) // %5B%5D = []
         : mapEntry(data, `&${type}`);

      return utils.saveChunked(utils.tpl(url, this.data), fragments);
   }

   shareWithProject(project) {
      const url = `{host}/projects/{project}/subjects/{subject}/experiments/{experiment}/projects/${project}`;
      return http.put(utils.tpl(url, this.data));
   }

   unshareWithProject(project) {
      const url = `{host}/projects/${project}/experiments/{experiment}/`;
      return http.del(utils.tpl(url, this.data));
   }

   delete() {
      const url = '{host}/projects/{project}/subjects/{subject}/experiments/{experiment}';
      return http.del(utils.tpl(url, this.data));
   }

}
